module.exports = __webpack_public_path__ + "img/Hickory V1 960x540.a5affa44.png";